import { VerificationResult, VerificationState } from "backend/datainput";

type TValidatorFunction = (
  value: VerificationState
) => VerificationResult | undefined;
const validateInputForm = (
  value: VerificationState,
  fns: TValidatorFunction[]
) => {
  for (let i = 0; i < fns.length; i += 1) {
    const res = fns[i](value);
    if (res) return res;
  }
  return {
    success: true,
    errorMessages: [],
  };
};

export default validateInputForm;
